import CustomerServicePage from '@/views/CustomerServicePage'

export default function Page() {
  return <CustomerServicePage />
}
